import { render, staticRenderFns } from "./settlement_assistance.vue?vue&type=template&id=67794e91&"
import script from "./settlement_assistance.vue?vue&type=script&lang=js&"
export * from "./settlement_assistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports